export const PARAMS_NAME = {
    onwRevenue: 'ONW Revenue',
    totalRevenue: 'Total Revenue',
    roi: 'ROI',
    roiPercent: 'ROI %',
    wonPercent: 'WIN %',
    ctrPercent: 'CTR %',
    totalClicks: 'Total Clicks',
    invalidClicks: 'Invalid Clicks',
    invalidCost: 'Invalid Cost',
    finalCost: 'Final Cost',
    cpc: 'CPC',
    ctr: 'CTR'
};
export const NAN_PARAMS = {
    datetime: 1,
    validity: 1,
    date: 1,
    hour: 1,
    affid: 1,
    subid: 1,
    country: 1
};



// WEBPACK FOOTER //
// ./src/scenes/PushapiHourly/config.js